import LocationContainer from 'bento-ordering/locations/containers/LocationsContainer';
import LocationOffline from 'bento-ordering/locations/containers/LocationOffline';

import {
  LOCATION_BASE,
  LOCATION_DETAIL,
  LOCATION_OFFLINE
} from 'bento-ordering/locations/constants/paths';
import LocationOfflinePageLayout from 'bento-ordering/locations/layouts/LocationOfflinePageLayout';
import LocationListOuterLayout from 'bento-ordering/locations/layouts/LocationListOuterLayout';
import { generatePath } from 'bento-ordering/utils/generatePath';
import { MENU } from 'bento-ordering/menus/constants/entities';

const routes = [
  {
    path: LOCATION_BASE,
    exact: true,
    Component: LocationContainer,
    Layout: LocationListOuterLayout
  },
  {
    path: LOCATION_OFFLINE,
    exact: true,
    Component: LocationOffline,
    Layout: LocationOfflinePageLayout
  },
  {
    path: LOCATION_DETAIL,
    exact: true,
    redirect: ({ slug }) => generatePath(MENU, 'menu', { slug })
  }
];

export default routes;
